import { i18n } from '@/store/i18n';
import { http } from '@/utils/http';
import { useUserStoreHook } from '@/store/modules/user';
import {
  Connection,
  DataLine,
  Notebook,
  Postcard,
  Sunrise,
  Tickets,
  User,
} from '@element-plus/icons-vue';
import { h } from 'vue';

const exampleMenu: RouteConfigsTable[] = [
  {
    path: '/permission',
    meta: {
      title: '权限管理',
      icon: 'ep:lollipop',
      rank: 10,
      showLink: false,
    },
    children: [
      {
        path: '/permission/page/index',
        name: 'PermissionPage',
        meta: {
          title: '页面权限',
          roles: [],
        },
      },
      {
        path: '/permission/button',
        meta: {
          title: '按钮权限',
          roles: [],
        },
        children: [
          {
            path: '/permission/button/router',
            component: 'permission/button/index',
            name: 'PermissionButtonRouter',
            meta: {
              title: '路由返回按钮权限',
              auths: [
                'permission:btn:add',
                'permission:btn:edit',
                'permission:btn:delete',
              ],
            },
          },
          {
            path: '/permission/button/login',
            component: 'permission/button/perms',
            name: 'PermissionButtonLogin',
            meta: {
              title: '登录接口返回按钮权限',
            },
          },
        ],
      },
    ],
  },
];

/** 控制菜单数据 */
export const getAsyncRoutes = async () => {
  const localMenus: RouteConfigsTable[] = [
    {
      path: '/exhibitor-service-manual',
      meta: {
        title: i18n.t('zhan-shang-fu-wu-shou-ce-xia-zai'),
        icon: Notebook,
      },
      children: [
        {
          path: '/exhibitor-service-manual/download',
          name: 'ExhibitorServiceManualDownloadPage',
          meta: {
            title: i18n.t('zhan-shang-fu-wu-shou-ce-xia-zai'),
          },
        },
      ],
    },
    {
      path: '/promote-online-forms',
      meta: {
        title: i18n.t('xuan-chuan-tui-guang-zai-xian-biao-ge'),
        icon: Postcard,
      },
      children: [
        {
          path: '/promote-online-forms/program-materials',
          name: 'PromoteOnlineFormsProgramMaterialsPage',
          meta: {
            title: i18n.t('a31-chang-kan-zi-liao'),
            required: true,
          },
        },
        {
          path: '/promote-online-forms/exhibition-promotion',
          name: 'PromoteOnlineFormsExhibitionPromotionPage',
          meta: {
            title: i18n.t('a32-zhan-hui-xuan-chuan'),
            required: true,
          },
        },
        {
          path: '/promote-online-forms/sponsor-opportunity',
          name: 'PromoteOnlineFormsSponsorOpportunity',
          meta: {
            title: i18n.t('a33-zan-zhu-liang-ji'),
            disabled: true,
          },
        },
        {
          path: '/promote-online-forms/international-conference',
          name: 'PromoteOnlineFormsInternationalConference',
          meta: {
            title: i18n.t('a34-guo-ji-ji-shu-hui-yi'),
            disabled: true,
          },
        },
      ],
    },
    {
      path: '/exhibitor-badge',
      meta: {
        title: i18n.t('can-zhan-shang-zheng'),
        icon: User,
      },
      children: [
        {
          path: '/exhibitor-badge',
          name: 'ExhibitorBadge',
          meta: {
            title: i18n.t('can-zhan-shang-zheng'),
            required: true,
          },
        },
      ],
    },
    {
      path: '/museum-sheet',
      meta: {
        title: i18n.t('da-jian-ji-jin-guan-xiang-guan-biao-ge'),
        icon: Connection,
      },
      children: [
        {
          path: '/museum-sheet/sheet1',
          name: 'Sheet1',
          meta: {
            title: i18n.t('da-hui-bao-guan-fu-wu-biao-ge'),
          },
        },
        {
          path: '/museum-sheet/sheet2',
          name: 'Sheet2',
          meta: {
            title: i18n.t('zhi-ding-cheng-jian-shang-fu-wu-biao-ge'),
          },
        },
        {
          path: '/museum-sheet/sheet3',
          name: 'Sheet3',
          meta: {
            title: i18n.t('zhi-ding-cheng-yun-shang-fu-wu-biao-ge'),
          },
        },
        {
          path: '/museum-sheet/contractor-material',
          name: 'ContractorMaterial',
          meta: {
            title: i18n.t('fei-zhi-ding-cheng-jian-shang-zi-liao'),
            showLink: false,
          },
        },
        {
          path: '/museum-sheet/construction-deposit',
          name: 'ConstructionDeposit',
          meta: {
            title: i18n.t('shi-gong-ya-jin'),
            showLink: false,
          },
        },
        {
          path: '/museum-sheet/license-collection',
          name: 'LicenseCollection',
          meta: {
            title: i18n.t('jin-che-guan-huo-che-pai-hao-ma-shou-ji'),
            showLink: false,
          },
        },
        {
          path: '/museum-sheet/exhibits-information',
          name: 'ExhibitsInformation',
          meta: {
            title: i18n.t('zhong-xing-ji-da-xing-zhan-pin-zi-liao'),
            showLink: false,
          },
        },
      ],
    },
    // {
    //   path: '/bill-collect',
    //   meta: {
    //     title: i18n.t('guo-shui-fa-piao-kai-piao-zi-liao'),
    //     icon: Tickets,
    //   },
    //   children: [
    //     {
    //       path: '/bill-collect',
    //       name: 'BillCollect',
    //       meta: {
    //         title: i18n.t('guo-shui-fa-piao-kai-piao-zi-liao'),
    //       },
    //     },
    //   ],
    // },
    {
      path: '/other-packages',
      meta: {
        title: i18n.t('qi-ta-pei-tao'),
        icon: DataLine,
      },
      children: [
        {
          path: '/other-packages/download',
          name: 'OtherPackagesDownload',
          meta: {
            title: i18n.t('da-hui-xuan-chuan-zi-liao-xia-zai'),
          },
        },
        {
          path: '/other-packages/activity',
          name: 'OtherPackagesActivity',
          meta: {
            title: i18n.t('zhan-shang-huo-dong-shang-chuan'),
          },
        },
        {
          path: '/other-packages/information',
          name: 'OtherPackagesInformation',
          meta: {
            title: i18n.t('zhan-shang-zi-xun'),
          },
        },
        {
          path: '/other-packages/info-detail',
          name: 'OtherPackagesInfoDetail',
          meta: {
            title: i18n.t('zhan-shang-zi-xun-xiang-qing'),
            showLink: false,
          },
        },
      ],
    },
    {
      path: '/apply-visa',
      meta: {
        title: i18n.t('shen-qing-zhong-guo-qian-zheng-zhi-yao-qing-han'),
        icon: Sunrise,
      },
      children: [
        {
          path: '/apply-visa',
          name: 'ApplyVisa',
          meta: {
            title: i18n.t('shen-qing-zhong-guo-qian-zheng-zhi-yao-qing-han'),
          },
        },
      ],
    },
    {
      path: '/exhibitor-invite',
      meta: {
        title: i18n.t('zhan-shang-yao-yue'),
        icon: Sunrise,
      },
      children: [
        {
          path: '/exhibitor-invite',
          name: 'ExhibitorInvite',
          meta: {
            title: i18n.t('zhan-shang-yao-yue'),
            disabled: true,
          },
        },
      ],
    },
  ];

  // 当展商类型为 SS 时，隐藏"指定承建商服务表格"菜单
  const userStore = useUserStoreHook();
  if (userStore.exhibitorType === 'SS') {
    const museumSheet = localMenus.find(m => m.path === '/museum-sheet');
    if (museumSheet?.children) {
      museumSheet.children = museumSheet.children.filter(
        child => child.path !== '/museum-sheet/sheet2',
      );
    }
  }

  return {
    // data: exampleMenu,
    data: localMenus,
  };
};
